import { render, staticRenderFns } from "./evalution.vue?vue&type=template&id=5af3c51a&"
import script from "./evalution.vue?vue&type=script&lang=js&"
export * from "./evalution.vue?vue&type=script&lang=js&"
import style0 from "./evalution.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports